import {
  enableProdMode,
  provideZoneChangeDetection,
  importProvidersFrom
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { TealiumUtagService } from './app/tealium/utag.service';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { provideRouter } from '@angular/router';
import { routes, routeComponents } from './app/routes';
import { StoreModule } from '@ngrx/store';
import { reducers } from './app/reducer';
import { Angulartics2Module } from 'angulartics2';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppComponent } from './app/app';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      ReactiveFormsModule,
      FormsModule,
      MatDialogModule,
      MatTabsModule,
      MatInputModule,
      MatSelectModule,
      MatNativeDateModule,
      MatDatepickerModule,
      MatButtonModule,
      BrowserAnimationsModule,
      OverlayModule,
      ReactiveFormsModule,
      StoreModule.forRoot(reducers),
      Angulartics2Module.forRoot(),
      !environment.production
        ? StoreDevtoolsModule.instrument({ maxAge: 25, connectInZone: true })
        : []
    ),
    { provide: TealiumUtagService, useClass: TealiumUtagService },
    { provide: MatDialogRef, useValue: {} },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes)
  ]
});
